import { Box, Button, Field, Heading, Modal, Textarea } from '@hover/blueprint';
import React, { useState } from 'react';

import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

interface RevertModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (feedback: string) => void;
}

export const RevertModal: React.FC<RevertModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
}) => {
  const t = useTranslate(TranslationNamespace.PROPERTY_DETAILS);
  const [feedback, setFeedback] = useState('');

  return (
    <Modal
      footer={
        <Box>
          <Button
            color="primary"
            fill="outline"
            marginRight={200}
            onClick={onCancel}
          >
            {t('cancel')}
          </Button>
          <Button color="primary" onClick={() => onConfirm(feedback)}>
            {t('send')}
          </Button>
        </Box>
      }
      header={
        <Heading marginBottom={0} size={400}>
          {t('giveFeedback')}
        </Heading>
      }
      isClosable
      isOpen={isOpen}
      onClose={onCancel}
      size="small"
    >
      <Field
        label={t('revertPropertyDetailsLabel')}
        name="revertPropertyDetailsFeedback"
      >
        <Textarea
          name="revertPropertyDetailsFeedback"
          onChange={event => setFeedback(event.target.value)}
          rows={3}
          value={feedback}
        />
      </Field>
    </Modal>
  );
};
